import Auth from "./auth";
import Product from "./product";
import Addbanner from "./addbanner";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Auth,
  Product,
  Addbanner,
};
